<template>
  <div class="worker-manage" v-loading="loading">
    <iframe v-show="iframeSrc" class="worker-manage-iframe" :src="iframeSrc" @load="handleOnload" />
    <div style="height: 100%" v-if="!loading && !iframeSrc">
      <el-empty style="height: 100%" description="暂无数据" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { loginZzy, loginMdm } from '@/apis/user'
import { useRoute } from 'vue-router'
import { useAccountStore } from '@/stores/modules/account'
const accountStore = useAccountStore()
const userInfo = accountStore.userInfo
const route = useRoute()
const mdmUrl = import.meta.env.VITE_APP_MDM_URL

defineOptions({
  name: 'WorkerManage'
})

const iframeSrc = ref<string>(``)
const loading = ref<boolean>(true)

watch(
  () => route.name,
  val => {
    if (val === 'WorkerManage' && iframeSrc.value === '') {
      if (userInfo?.isMdm) {
        goMdm()
      } else {
        goZzy()
      }
    }
  },
  {
    immediate: true
  }
)

function goZzy() {
  try {
    const id: string = userInfo.id as string
    let formData = new FormData()
    formData.append('userId', id)
    loginZzy(formData).then(res => {
      iframeSrc.value = res
    })
  } catch (e) {
    loading.value = false
  }
}

// https://saas.jiyunn.cn/#/?iframe=cpsSaas&mdmToken={token}
function goMdm() {
  try {
    const loginName: string = userInfo.username as string
    loginMdm({ loginName }).then(token => {
      iframeSrc.value = mdmUrl + `/#/?iframe=cpsSaas&mdmToken=${token}`
    })
  } catch (e) {
    loading.value = false
  }
}

function handleOnload() {
  loading.value = false
}
</script>
<style lang="scss" scoped>
.worker-manage {
  padding: 16px;
  height: 100%;
  &-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
